<template>
<div>
    <router-link v-for="notification in notificationList" 
        :key="notification.id"
        :to="`/timeline/${notification.activity.id}`" class="item">
        <dp v-if="notification.senders.length == 1" :who="notification.senders[0]" />
        <div v-if="notification.senders.length > 1" class="double-dp">
            <dp :who="notification.senders[0]" />
            <dp :who="notification.senders[1]" />
        </div>
        <p>
            {{ notificationText(notification) }}
        </p>

        <!-- Byline with time of notification -->
        <small class="pale">
            {{ notification.updated_at | time }}
        </small>
    </router-link>
</div>
</template>

<script>
import _ from 'underscore'
import userlink from 'components/user-link.vue'
import dp from 'components/dp.vue'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { 'user-link': userlink, 'dp': dp },
    props: [ 'notifications' ],
    computed: {
        notificationList () {
            const that = this

            return _.map(this.notifications, function(notification) {
                const match = notification.activity.match;

                if (match) {
                    match.player_me = match.player_a_id == that.user.id ?
                        match.player_a : match.player_b
                    match.player_other = match.player_a_id == that.user.id ?
                        match.player_b : match.player_a
                }

                return notification
            })
        }
    },
    methods: {
        notificationText (notification) {
            const senders = this.listNames(notification.senders)
            var activity = ''

            switch (notification.activity.type) {
                case 'post-text':
                    activity = 'dein Post'
                    break
                case 'match-played':
                    activity = 'dein Spiel gegen ' + base.filters.name(notification.activity.match.player_other)
                    break
            }  

            switch (notification.type) {
                case 'like':
                    return `${senders} gefällt ${activity}`
                case 'comment':
                    const verb = notification.senders.length > 1 ? 'haben' : 'hat'
                    return `${senders} ${verb} ${activity} kommentiert`
            }
        },

    }
}
</script>



// WEBPACK FOOTER //
// notifications.vue?6f33fc0e